<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <span class="title">{{ $t('invoices.add') }}</span>
            </div>
            <div class="col-6 d-flex justify-content-end">
                <genericBtnComponent :disabled="!isSupplier() || !ValidatedSupplier || loader"
                    :ClickFun="validateFormInvoice" svg="1" :Title="$t('invoices.save')" :loader="loader" />
            </div>
        </div>
    </div>
    <v-card elevation="0">
        <div class="row ma-4">
            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('invoices.reference') }}<span
                            class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <v-text-field v-model="Reference" id="Reference" name="Reference" maxlength="50" hide-details
                        persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('invoices.reference') })"
                        variant="outlined"></v-text-field>
                    <span class="warningHint" id="WarningMsgReference">{{ msg.Reference }}</span>
                </div>
            </div>
            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('invoices.title') }}<span class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <v-text-field v-model="Title" id="Title" name="Title" maxlength="30" hide-details
                        persistent-placeholder :placeholder="$t('placeholder.enter', { itm: $t('invoices.title') })"
                        variant="outlined"></v-text-field>
                    <span class="warningHint" id="WarningMsgTitle">{{ msg.Title }}</span>
                </div>
            </div>
            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('invoices.company') }}<span
                            class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <v-autocomplete id="Company" name="Company" class="pl-0 pr-6" variant="outlined" v-model="IdCompany"
                        v-model:search="CompanySearch" persistent-placeholder
                        :placeholder="$t('placeholder.select', { itm: $t('invoices.company') })" :items="CompanyList"
                        item-title="brandName" item-value="id" hide-details>
                        <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName" />
                        </template>
                    </v-autocomplete>
                    <span class="warningHint" id="WarningMsgCompany">{{ msg.Company }}</span>
                </div>
            </div>
            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('invoices.purchaseOrder') }}<span
                            class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <v-autocomplete id="PurchaseOrder" name="PurchaseOrder" class="pl-0 pr-6" variant="outlined"
                        v-model="IdPurchaseOrder" v-model:search="PurchaseOrderSearch" persistent-placeholder
                        :placeholder="$t('placeholder.select', { itm: $t('invoices.purchaseOrder') })"
                        :items="PurchaseOrderList" item-title="title" item-value="id" hide-details clearable no-filter>
                    </v-autocomplete>
                    <span class="warningHint" id="WarningMsgPurchaseOrder">{{ msg.PurchaseOrder }}</span>
                </div>
            </div>
            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('invoices.currency') }}<span
                            class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <v-autocomplete id="Devise" name="Devise" class="pl-0 pr-6" variant="outlined" v-model="Devise"
                        persistent-placeholder :placeholder="$t('placeholder.select', { itm: $t('invoices.currency') })"
                        :items="DeviseList" item-title="name" item-value="symbol" hide-details
                        :readonly="IdPurchaseOrder">
                        <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" variant="text" :id="index" :name="item.name">
                                {{ item.name }}
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                    <span class="warningHint" id="WarningMsgDevise">{{ msg.Devise }}</span>
                </div>
            </div>
            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('invoices.deadline') }}<span
                            class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <dateField v-model="Deadline" :min-date="new Date('2000-01-01')" />
                    <span class="warningHint" id="WarningMsgDeadline">{{ msg.Deadline }}</span>
                </div>
            </div>

            <div class="col-5 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('invoices.invoice') }}<span
                            class="red">*</span></v-card-title>
                </div>
                <div class="row ml-0">
                    <uploadDocument @addDocument="setidentityDocument" :showUpload="true">
                        <template v-slot:DocumentsList>
                            <div @mouseover="setHover(-1)" @mouseout="setHover(null)"
                                style="display: flex; position: relative;">
                                <span v-if="identityDocument"
                                    style="color: blue; cursor: pointer; margin-left: 14px; display: flex; text-align: start"
                                    @click="downloadDocumentInvoices(identityDocument)"
                                    :title="$t('actions.download') + ' ' + identityDocument.name">
                                    {{ identityDocument.name }}</span>


                            </div>
                        </template>
                    </uploadDocument>
                    <span class='warningHint' id="WarningMsgStatus">{{ msg.identityDocument }}</span>
                </div>
            </div>
            <div class="col-2"></div>
            <div class="col-5 justify-content-start">
                <div class="row ">
                    <v-card-title class="text-left">{{ $t('purchaseOrder.AutresDocument') }}</v-card-title>
                </div>
                <div class="row ml-0">
                    <uploadMultiDocument v-on:addMultiDocument="setidentityDocuments" :showUpload="true">
                        <template v-slot:DocumentsList>
                            <div style="max-height: 60px; overflow-y:scroll;">
                                <div v-for="(fileName, index) in MultiFileList" :key="index">
                                    <div @mouseover="setHover(index)" @mouseout="setHover(null)"
                                        style="display: flex; position: relative;">
                                        <span style="color: blue; cursor: pointer; text-align: start; max-width: 95%;"
                                            @click="downloadMultiDocumentInvoices(fileName, index)"
                                            :title="$t('actions.download') + ' ' + fileName">{{ fileName }}</span>
                                        <v-icon v-show="isHovered == index"
                                            @click="showDeleteConfirmationDialog(fileName, index)" class="ml-2"
                                            style="color: red">mdi-close-circle-outline</v-icon>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </uploadMultiDocument>
                </div>
            </div>
            <!--<div @click="addLine" class="border-right text-center"
                                    style="cursor: pointer; color: rgba(0, 4, 255, 0.38); text-decoration: underline;">
                                    {{ $t('purchaseOrder.Ajouterline') }}</div>-->
            <v-divider></v-divider>
            <v-table v-if="lines.length > 0" theme="white" class="table-responsive rounded-table" style="width: 100%">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="border-right">{{ $t('purchaseOrder.title') }}</th>
                            <th class="border-right">{{ $t('purchaseOrder.quantity') }}</th>
                            <th class="border-right">{{ $t('purchaseOrder.amountHT') }}</th>
                            <th class="border-right">{{ $t('purchaseOrder.tax') }}</th>
                            <th class="border-right">{{ $t('purchaseOrder.montantHT') }}</th>
                            <th class="border-right">{{ $t('purchaseOrder.montantTotal') }}</th>
                            <th class="border-right">{{ $t('invoices.amoutToBePaid') }}</th>
                            <!-- <th class="border-right">{{ $t('actions') }}</th> -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(line, index) in lines" :key="index" class="border-bottom ">
                            <td class="border-right col-3">
                                <p class="align-right align-left">{{ line.title }}</p>
                            </td>

                            <td class="border-right col-1">
                                <p class="align-right">{{ line.quantity }}</p>
                            </td>
                            <td class="border-right col-1">

                                <p class="align-right">{{ formatPrice(line.unitPrice) }}</p>

                            </td>
                            <td class="border-right col-1">
                                <p class="align-right">{{ line.tax }} %</p>

                            </td>
                            <td class="border-right col-1">
                                <p class="align-right">{{ formatPrice(line.AmountHTVA) }}</p>
                            </td>
                            <td class="border-right col-1">
                                <p class="align-right">{{ formatPrice(line.MTTotal) }}</p>
                            </td>
                            <td class="align-top border-right col-2">
                                <div class="d-flex align-center">
                                    <v-text-field class='text-wrap' v-model.number="line.amountToPay" type="number"
                                        :max="line.amountTTC - line.amountPaid"
                                        :rules="[v => (parseFloat(v) <= (line.amountTTC - line.amountPaid)) || 'Amount exceeds available balance']"
                                        :placeholder="$t('placeholder.enter', { itm: $t('purchaseOrder.amountHT') })"
                                        @input="enforceMaxValue(line)" @blur="enforceMaxValue(line)" hide-details
                                        variant="outlined" :suffix="Devise"></v-text-field>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-table>
            <div v-if="lines.length > 0" class="row mt-4">
                <div class="col-8"></div>
                <div class="col-4 totals">
                    <div v-for="(amount, tax) in totaltaxs" :key="tax">
                        <p class="align-right">
                            <span>{{ $t("purchaseOrder.taxAmount") }} {{ tax }}% :</span>
                            <span class="amount">{{ taxDetails[tax].total.toFixed(3) }} {{ Devise }}</span>
                        </p>
                        <p class="align-right sub-detail">
                            <span>{{ $t("invoices.alreadyPaid") }}:</span>
                            <span class="amount">{{ taxDetails[tax].paid.toFixed(3) }} {{ Devise }}</span>
                        </p>
                        <p class="align-right sub-detail">
                            <span>{{ $t("invoices.toBePaid") }}:</span>
                            <span class="amount">{{ taxDetails[tax].toPay.toFixed(3) }} {{ Devise }}</span>
                        </p>
                    </div>

                    <v-divider class="custom-divider my-4"></v-divider>

                    <p class="align-right total-line">
                        <span>{{ $t("invoices.totalAmount") }}:</span>
                        <span class="amount"><strong>{{ grandTotal.toFixed(3) }} {{ Devise }}</strong></span>
                    </p>
                    <p class="align-right total-line">
                        <span>{{ $t("invoices.totalPaid") }}:</span>
                        <span class="amount"><strong>{{ totalPaid.toFixed(3) }} {{ Devise }}</strong></span>
                    </p>
                    <p class="align-right total-line">
                        <span>{{ $t("invoices.totalToPay") }}:</span>
                        <span class="amount"><strong>{{ totalToPay.toFixed(3) }} {{ Devise }}</strong></span>
                    </p>
                </div>
            </div>
        </div>
    </v-card>
    <dialogDelete v-if="selectedIndex !== null" v-model="showDeleteDialog" :yes="confirmDelete" :status="false"
        :title="selectedFileName" :loader="deleteLoader"></dialogDelete>
</template>
<script>
import dialogDelete from "@/genericComponent/dialogDelete.vue"
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import uploadMultiDocument from "@/genericComponent/uploadMultiDocument.vue"
import { CreateInvoice, GetCompanyFromInvoices, GetPurchaseOrderFromInvoices, isSupplier, CanValideFactureByPurchaseOrder, GetTaxListByCmpanyId, InvoiceIsExistReference, GetDeviseFromPurchaseOrder, getPurchaseOrderItemsForInvoice, formatPrice } from "@/api/index";
import deviseJson from "@/data/DevisesList.json"
import dateField from "@/genericComponent/date-field.vue";
import uploadDocument from "@/genericComponent/uploadDocument.vue"
export default {
    components: { genericBtnComponent, dateField, uploadDocument, uploadMultiDocument, dialogDelete },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.invoices');
    },
    data: () => ({
        showDeleteDialog: null,
        ValidatedSupplier: false,
        Reference: null,
        Title: null,
        Amount: null,
        Deadline: null,
        Devise: null,
        Tax: null,
        IdCompany: null,
        CompanySearch: null,
        CompanyList: [],
        msg: [],
        TaxList: [],
        DeviseList: deviseJson,
        loader: false,
        identityDocument: null,
        identityDocuments: [],
        IdPurchaseOrder: null,
        PurchaseOrderSearch: null,
        PurchaseOrderList: [],
        isHovered: null,
        selectedIndex: null,
        selectedFileName: null,
        ListProductsPerPO: [],
        lines: [],
        TotalTTC: null,
    }),
    created() {
        this.isValidatedSupplier();
        this.GetCompanyList();
        this.GetPurchaseOrderList();
    },
    watch: {
        CompanySearch(value) {
            if (this.CompanySearch != null && this.CompanySearch.length == 1) this.CompanySearch = value.trim();
            this.GetCompanyList();
        },
        PurchaseOrderSearch(value) {
            if (this.PurchaseOrderSearch != null && this.PurchaseOrderSearch.length == 1) this.PurchaseOrderSearch = value.trim();
            this.GetPurchaseOrderList();
        },
        IdCompany(value) {
            if (value != null) this.GetTaxListByCmpanyId(value);
            else this.Tax = null
        },
        IdPurchaseOrder(value) {
            if (value) {
                this.getDeviseFromPurchaseOrder(value)
            }
        }
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        enforceMaxValue(line) {
            const maxValue = line.amountTTC - line.amountPaid;
            if (parseFloat(line.amountToPay) > maxValue) {
                line.amountToPay = maxValue;
            }
        },
        confirmDelete() {
            if (this.selectedIndex !== null) {
                /*if (this.identityDocument.name === this.selectedFileName && this.selectedIndex === -1) {
                    this.setidentityDocument(null);
                } else {}*/
                this.identityDocuments.splice(this.selectedIndex, 1);

                this.selectedIndex = null;
                this.selectedFileName = null;
                this.showDeleteDialog = false;
            }
        },
        showDeleteConfirmationDialog(filename, index) {
            this.showDeleteDialog = true;
            this.selectedFileName = filename;
            this.selectedIndex = index;
        },
        downloadMultiDocumentInvoices(fileName, index) {
            var reader = new FileReader();
            reader.readAsDataURL(this.identityDocuments[index]);
            reader.onloadend = function () {
                var mimeType = fileName.split('.')[1];
                var base64data = reader.result;

                switch (mimeType) {
                    case 'pdf':
                        mimeType = 'application/pdf';
                        break;
                    case 'png':
                        mimeType = 'image/png';
                        break;
                    case 'jpg':
                    case 'jpeg':
                        mimeType = 'image/jpeg';
                        break;
                    default:
                        mimeType = 'application/octet-stream';
                        break;
                }
                const linkSource = `data:${mimeType};${base64data}`;
                const downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
        },
        downloadDocumentInvoices(file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function () {
                var mimeType = file.name.split('.')[1];
                var base64data = reader.result;

                switch (mimeType) {
                    case 'pdf':
                        mimeType = 'application/pdf';
                        break;
                    case 'png':
                        mimeType = 'image/png';
                        break;
                    case 'jpg':
                    case 'jpeg':
                        mimeType = 'image/jpeg';
                        break;
                    default:
                        mimeType = 'application/octet-stream';
                        break;
                }
                const linkSource = `data:${mimeType};${base64data}`;
                const downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = file.name;
                downloadLink.click();
            }
        },
        setHover(index) {
            this.isHovered = index;
        },
        setidentityDocument(value) {
            if (value !== null) {
                this.identityDocument = value
                this.msg["identityDocument"] = "";
            }

        },
        setidentityDocuments(value) {
            this.identityDocuments.push(...value);
        },
        isSupplier() {
            return isSupplier()
        },
        isValidatedSupplier() {
            this.ValidatedSupplier = this.isSupplier();
        },
        GetCompanyList() {
            GetCompanyFromInvoices(this.CompanySearch)
                .then((res) => {
                    this.CompanyList = res.data;
                })
        },
        GetTaxListByCmpanyId(companyId) {
            GetTaxListByCmpanyId(companyId).then((res) => {
                this.TaxList = res.data;
            })
        },
        GetPurchaseOrderList() {
            GetPurchaseOrderFromInvoices(this.PurchaseOrderSearch)
                .then((res) => {
                    this.PurchaseOrderList = res.data;
                    this.PurchaseOrderList.map((item) => { item.title = item.reference })
                })
        },
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        ActivePurchaseOrderInsufficientSnackBar() {
            this.getParent('MainLayout').ActivePurchaseOrderInsufficientSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        createInvoice() {
            CreateInvoice(
                this.Reference,
                this.Title,
                this.Devise,
                this.Deadline,
                this.IdCompany,
                this.IdPurchaseOrder,
                this.identityDocument,
                this.identityDocuments,
                this.lines
            ).then(() => {
                this.ActiveSavedSnackBar();
            }).catch(() => {
                this.ActiveWarningSnackBar();
            }).finally(() => {
                this.loader = false;
                this.$router.push({ path: "/Invoices" });
            });
        },
        validateForm() {
            if (this.IdPurchaseOrder) {
                CanValideFactureByPurchaseOrder(this.IdPurchaseOrder, this.AmountTTC).then((r) => {
                    if (r.data) {
                        this.createInvoice();
                    } else {
                        this.ActivePurchaseOrderInsufficientSnackBar();
                        this.loader = false;
                    }
                })
            } else {
                console.log("None")
            }
        },
        async IsExistReference() {
            const r = await InvoiceIsExistReference(null, this.Reference);
            return r.data;
        },
        async validateFormInvoice() {
            this.loader = true

            if (!this.Reference || this.Reference.length == 0) {
                this.msg["Reference"] = this.$t('invoices.referenceRequired');
            } else if (await this.IsExistReference() == true) {
                this.msg["Reference"] = this.$t('warningInput.exist', { itm: this.$t('invoices.reference') });
            } else {
                this.msg["Reference"] = "";
            }

            if (!this.Title || this.Title.length == 0) {
                this.msg["Title"] = this.$t('invoices.titleRequired');
            } else {
                this.msg["Title"] = "";
            }

            if (!this.IdCompany || this.IdCompany.length == 0) {
                this.msg["Company"] = this.$t('invoices.companyRequired');
            } else {
                this.msg["Company"] = "";
            }

            if (!this.Devise || this.Devise.length == 0) {
                this.msg["Devise"] = this.$t('invoices.currencyRequired');
            } else {
                this.msg["Devise"] = "";
            }


            if (
                this.IdPurchaseOrder == null ||
                this.IdPurchaseOrder.length === 0
            ) {
                this.msg["PurchaseOrder"] = this.$t(
                    `invoices.purchaseOrderRequired`
                );
            } else {
                this.msg["PurchaseOrder"] = "";
            }

            if (!this.Deadline || this.Deadline.length == 0) {
                this.msg["Deadline"] = this.$t('invoices.deadlineRequired');
            } else if (this.Deadline < "1000-01-01") {
                this.msg["Deadline"] = this.$t('warningInput.wrong', { itm: this.$t('invoices.deadline') });
            } else {
                this.msg["Deadline"] = "";
            }
            if (this.identityDocument == null || this.identityDocument == "") {
                this.msg["identityDocument"] = this.$t('invoices.documentsTab.errors.identityDocument');
            } else {
                this.msg["identityDocument"] = "";
            }

            if (this.msg["Devise"] == "" && this.msg["Title"] == ""
                && this.msg["Company"] == ""
                && this.msg["Deadline"] == ""
                && this.msg["identityDocument"] == ""
                && this.msg["Reference"] == ""
                && this.msg["PurchaseOrder"] == "") {
                this.validateForm();
            } else { this.loader = false }
        },
        getDeviseFromPurchaseOrder(IdPurchaseOrder) {
            GetDeviseFromPurchaseOrder(IdPurchaseOrder).then(r => {
                this.Devise = r.data;
            })
            getPurchaseOrderItemsForInvoice(IdPurchaseOrder).then(r => {
                r.data.forEach(item => {
                    this.lines.push({
                        title: item.name,
                        quantity: item.quantity,
                        unitPrice: item.price,
                        amountPaid: item.amountPaid,
                        tax: item.tax,
                        AmountHTVA: item.amountHTVA,
                        MTTotal: item.amountTTC,
                        id: item.id,
                        amountToPay: 0,
                        errors: {}
                    }

                    );
                    this.TotalTTC = this.lines.reduce((sum, r) => sum + (parseFloat(r.MTTotal) || 0), 0);

                });
            });

        },
    },
    computed: {
        AmountTTC() {
            if (this.lines.length > 0) {
                return this.totalPaid;
            } else {
                return null;
            }
        },
        MultiFileList() {
            let list = [];
            if (this.identityDocuments) {
                this.identityDocuments.forEach(file => {
                    list.push(file.name)
                });
            }
            return list
        },
        totaltaxs() {
            const taxs = {};
            this.lines.forEach((line) => {
                if (line.tax) {
                    const amount = parseFloat(line.MTTotal) || 0;
                    if (taxs[line.tax]) {
                        taxs[line.tax] += amount;
                    } else {
                        taxs[line.tax] = amount;
                    }
                }
            });
            return taxs;
        },
        grandTotal() {
            return this.lines.reduce((total, line) => {
                return total + (parseFloat(line.MTTotal) || 0);
            }, 0);
        },
        totalPaid() {
            return this.lines.reduce((total, line) => {
                return total + (parseFloat(line.amountPaid) || 0);
            }, 0);
        },
        totalToPay() {
            return this.lines.reduce((total, line) => {
                return total + (parseFloat(line.amountToPay) || 0);
            }, 0);
        },
        taxDetails() {
            const details = {};
            const uniqueTaxes = [...new Set(this.lines.map(line => line.tax))];

            uniqueTaxes.forEach(tax => {
                if (tax) {
                    const taxLines = this.lines.filter(line => line.tax === tax);
                    const totalForTax = taxLines.reduce((sum, line) => sum + (parseFloat(line.MTTotal) || 0), 0);
                    const paidForTax = taxLines.reduce((sum, line) => sum + (parseFloat(line.amountPaid) || 0), 0);
                    const toPayForTax = taxLines.reduce((sum, line) => sum + (parseFloat(line.amountToPay) || 0), 0);

                    details[tax] = {
                        total: totalForTax,
                        paid: paidForTax,
                        toPay: toPayForTax
                    };
                }
            });

            return details;
        }
    }
};
</script>
<style scoped>
.title {
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    padding-left: 0;
    margin-top: 0;
    padding-top: 0;
}

.v-autocomplete {
    margin-left: 12px;
}

.text-wrap {
    white-space: pre-wrap !important;
    word-break: break-word;
    overflow-wrap: break-word;
}

.border-bottom {
    border-bottom: 1px solid #ddd;
}

.border-right {
    border: 1px dotted #ddd;
    text-align: center;
    padding: 2px 4px;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
}

:deep(.v-field__input) {
    white-space: pre-wrap !important;
}

.rounded-table {
    border-radius: 10px;
}

.custom-divider {
    border-top: 1px solid;
    border-color: currentColor;
}

.customWarningHint {
    color: #F25C5C;
    padding: 12px 0px 12px 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 0px;
    display: block;
    text-align: left;
    text-wrap: nowrap;
}

.totals {
    background-color: #f5f5f5;
    padding: 20px;
    border-radius: 8px;
}

.align-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.sub-detail {
    padding-left: 20px;
    color: #666;
    font-size: 0.9em;
}

.amount {
    min-width: 120px;
    text-align: right;
}

.total-line {
    font-weight: 500;
}

.align-left {
    text-align: left;
    position: relative;
}
</style>